import React from 'react';
import { useNavigate } from 'react-router-dom';
import { parseISO, addDays, isThisWeek, isFuture } from 'date-fns';
import styles from './EmptyState.module.css';

export default function EmptyState({ onUploadClick, hasMenus, menus }) {
  const navigate = useNavigate();

  if (hasMenus) {
    const current = menus.find(m => isThisWeek(parseISO(m.weekStart), { weekStartsOn: 1 }));
    const upcoming = menus.find(m => isFuture(parseISO(m.weekStart)));
    const target = current || upcoming || menus[0];

    if (target) {
      navigate(`/menu/${target.id}`, { replace: true });
      return null;
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.icon}>🥗</div>
        <h2 className={styles.title}>Nessun menu presente</h2>
        <p className={styles.desc}>
          Carica il tuo primo menu settimanale generato da Claude per iniziare.
        </p>
        <button className={styles.btn} onClick={onUploadClick}>
          Carica il primo menu
        </button>
      </div>
    </div>
  );
}
